import React from 'react';
import clsx from 'clsx';
import {
  FieldProps,
  TransportationProps,
  TransportationErrorProps,
} from 'enums/TransportationEnums';
import styles from '../Transportation.module.scss';
import {
  CategoryOptions,
  transformedDataTransportation,
} from 'views/CreateProductFlow/CreateProductFlowInterfaces';
import COSelect from 'shared/components/COSelect';
import { ErrorMessage, useFormikContext } from 'formik';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import COCheckbox from 'shared/components/COCheckbox';
import { FC } from 'react';
import { TemperatureControl } from '../TransportationConstants';

interface TransportationPackagingListInterface {
  isDisabled: boolean;
  formData?: transformedDataTransportation;
  handleOpenCreateSupplierModal: () => void;
  supplierOptionsList: CategoryOptions[];
  setSupplierDetails: (fieldName: string) => void;
  fetchData: (params?: { 'input-field': string }) => void;
}

const TransportationPackagingList: FC<
  TransportationPackagingListInterface
> = props => {
  const formikProps = useFormikContext();

  const {
    isDisabled,
    formData,
    handleOpenCreateSupplierModal,
    supplierOptionsList,
    setSupplierDetails,
    fetchData,
  } = props;

  return (
    <div className={styles.ingredientsFormContainer}>
      <h2>{TransportationProps.PACKAGE_MATERIAL_HEADING}</h2>
      {formData?.packageMaterials.map((material, index) => (
        <div key={`packaging-${index}`}>
          {material?.multipleOrigin?.map((_, originIndex) => (
            <React.Fragment key={`packaging-origin-${originIndex}`}>
              <div className={styles.fieldRow}>
                <div className={originIndex !== 0 ? styles.hide : ''}>
                  <p className={styles.pointer}>{index + 1}</p>
                </div>
                {/* Ingredient Name */}
                <div
                  className={clsx({
                    [styles.originContainer]: true,
                    [styles.hide]: originIndex !== 0,
                  })}>
                  <COSelect
                    key={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_NAME}`}
                    name={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_NAME}`}
                    label={FieldProps.PACKAGING_NAME_PLACEHOLDER}
                    placeholderstring={FieldProps.PACKAGING_NAME_PLACEHOLDER}
                    disabled={isDisabled ? true : true}
                  />
                </div>
                {/* Ingredient Origin Field */}
                <div className={styles.originContainer}>
                  <COSelect
                    key={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.ORIGIN}`}
                    name={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.ORIGIN}`}
                    label={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
                    placeholderstring={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
                    disabled={isDisabled ? true : true}
                  />
                </div>
                {/* Supplier Field */}
                <div className={styles.originContainer}>
                  <COSelect
                    name={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.SUPPLIER_NAME}`}
                    key={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.SUPPLIER_NAME}`}
                    label={FieldProps.SUPPLIER_PLACEHOLDER}
                    placeholderstring={FieldProps.SUPPLIER_PLACEHOLDER}
                    options={supplierOptionsList}
                    disabled={isDisabled ? true : false}
                    onFocus={() => {
                      setSupplierDetails(
                        `${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.SUPPLIER_NAME}`
                      );
                      fetchData?.({
                        'input-field': 'packaging material name',
                      });
                    }}
                    dropdownRender={(menu: CategoryOptions[]) => {
                      return (
                        <>
                          <div
                            className={styles.dropdownCreateButton}
                            onClick={handleOpenCreateSupplierModal}>
                            <Add /> {TransportationProps.CREATE_SUPPLIER}
                          </div>
                          {menu}
                        </>
                      );
                    }}
                  />
                </div>
                <div className={styles.checboxContainer}>
                  <COCheckbox
                    name={`${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.VIA_AIR}`}
                    onChange={e =>
                      formikProps.setFieldValue(
                        `${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.VIA_AIR}`,
                        e.target.checked
                      )
                    }
                    disabled={isDisabled ? true : false}
                    label={
                      <div className={styles.checkboxLabel}>
                        <p>{FieldProps.VIA_AIR_LABEL}</p>
                      </div>
                    }
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TransportationPackagingList;
